export default __webpack_public_path__ + "static/media/motorcycle8.dc6aa906.jpg";